import * as generic from "@/store/generic/mutations/result-status.js";

export function clearError(state, payload) {
  generic.clearError(state, payload);
}

export function setError(state, payload) {
  generic.setError(state, payload);
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload);
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload);
}

export function setTicket(state, payload) {
  state.ticket = payload;
}

export function setTopic(state, payload) {
  state.topic = payload;
}

export function setPercent(state, payload) {
  state.percent = payload;
}

export function setUploading(state, payload) {
  state.uploading = payload;
}
